import api from '../../utils/api';
import {
    GET_ALL_TELEGRAM,
    GET_SPECIFIC_TELEGRAM,
    UPDATE_SPECIFIC_TELEGRAM,
    CREATE_NEW_TELEGRAM,
    REMOVE_TELEGRAM
} from './types';
import { NotificationManager } from 'react-notifications';

export const getAllTelegram = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/telegram', { params: filter }).then(res => {
            dispatch({ type: GET_ALL_TELEGRAM, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createTelegram = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/telegram', data).then(res => {
            dispatch({ type: CREATE_NEW_TELEGRAM, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getTelegram = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/telegram/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_TELEGRAM, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const updateTelegram = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/telegram/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_TELEGRAM, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeTelegram = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/telegram`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_TELEGRAM, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
